import { render, staticRenderFns } from "./plantilla.vue?vue&type=template&id=38f63c48&scoped=true"
import script from "./plantilla.vue?vue&type=script&lang=js"
export * from "./plantilla.vue?vue&type=script&lang=js"
import style0 from "./plantilla.vue?vue&type=style&index=0&id=38f63c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f63c48",
  null
  
)

export default component.exports